import { CancelToken } from "axios";

import { IAPIError } from "shared/types";
import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem } from "shared/types";
import { IUserDrivingPermitPatchData } from "Bands/types";

interface IJSONAPIData {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIUserDrivingPermitCollection {
  [IDataKeys.userDrivingPermit]: IJSONAPIData;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class UserDrivingPermitService {
  static createUserDrivingPermit = (
    data: IUserDrivingPermitPatchData
  ): Promise<IJSONAPIUserDrivingPermitCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.post({
          path: API_ENDPOINTS.USER_DRIVING_PERMITS,
          data,
        });
        resolve(response as IJSONAPIUserDrivingPermitCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_USER_DRIVING_PERMIT);
        reject({ error });
      }
    });

  static getUserDrivingPermits = (
    queryParams?: string | { [key: string]: string | number | undefined | string[] },
    cancelToken?: CancelToken
  ): Promise<IJSONAPIUserDrivingPermitCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.get({
          path: API_ENDPOINTS.USER_DRIVING_PERMITS,
          data: queryParams,
          cancelToken,
        });
        resolve(response as IJSONAPIUserDrivingPermitCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_USER_DRIVING_PERMITS);
        reject({ error });
      }
    });

  static editUserDrivingPermit = (
    id: string,
    data: IUserDrivingPermitPatchData
  ): Promise<IJSONAPIUserDrivingPermitCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.patch({
          path: API_ENDPOINTS.USER_DRIVING_PERMIT(id),
          data,
        });
        resolve(response as IJSONAPIUserDrivingPermitCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_USER_DRIVING_PERMIT);
        reject({ error });
      }
    });

  static deleteUserDrivingPermit = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.USER_DRIVING_PERMIT(id),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_USER_DRIVING_PERMIT);
        reject({ error });
      }
    });
}
